// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2BZI3","signatureButtonsRight":"ModalSign_signatureButtonsRight__M3mDC"};